import React from 'react'
import './OrganizationForm.css'

/** OWN COMPONENTS */
import PopUp from '../../PopUpNotification/PopUp'

/** IMPORT REACT TOOLBOX COMPONENTS */
import Button from 'react-toolbox/lib/button/Button';
import IconButton from "react-toolbox/lib/button/IconButton"
import Input from "react-toolbox/lib/input/Input"
import Autocomplete from 'react-toolbox/lib/autocomplete/Autocomplete';
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
import Chip from 'react-toolbox/lib/chip';
import Dialog from 'react-toolbox/lib/dialog/Dialog';

/*** REDUX  ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as OrganizationActions from "../../../../actions/organizations";

/*** REDUX ACTINS ***/
import '../../../../assets/react-toolbox/theme.css';


class StationListForm extends React.Component {
    constructor() {
        super();
        this.state = {
            newStation: false,
            addIconStation: "add_to_home_screen",
            Dialog: {
                active: false,
                alias: '',
                station: '',
            }
        };

        this.handleDialog = this.handleDialog.bind(this);
    }

    handleAddStation() {
        if (this.state.newStation) {
            this.setState({...this.state, newStation: false, addIconStation: "add_to_home_screen"});
        } else {
            this.setState({...this.state, newStation: true, addIconStation: "close"});
        }
    }

    handleChange(name, value) {

        if ( name === 'alias'){
            let newState = this.state.Dialog;
            newState.alias = value;
            this.setState({...this.state, Dialog: newState});
        }else {
            console.log(this.props.noStations);
            if (this.props.noStations.map(int => int.id).includes(value)) {
                let station = {
                    station_id: value,
                    organizations: [{
                        shortName: this.props.shortName,
                        alias: "New_Station"
                    }]
                };
                this.props.organizationActions.postStationOrg(station, (response, err) => {
                    if (err) {
                        console.log("ERROR -> " + response);
                        this.errorPopUp('Station has not been added', "");
                    }
                    this.handleAddStation();
                });
            }
        }
    }

    errorPopUp(title, msg) {
        this.props.errorPopUp(title, msg);
    }

    handleDeleteStation(station) {
        let newState = this.state;

        this.props.organizationActions.delStationOrg(this.props.shortName, station, (response, err) => {
            if (err) {
                console.log("ERROR -> " + response.toString());
                this.errorPopUp('Station has not been deleted', "");
            } else {
                newState.stations.forEach((item, i) => {
                    if (item.station === station) {
                        newState.stations.splice(i, 1);
                    }
                });
                newState.noStations.push(station);

                this.setState(newState);
            }
        });
    }

    handleAlias(station) {
        let newState = this.state.Dialog;

        newState.alias = station.alias;
        newState.station = station.station;
        newState.active = true;

        this.setState({...this.state, Dialog: newState});
    }

    handleStations() {

        return this.props.stations.map((station, key) => {
            return (
                <ListItem
                    key={key}
                    caption={`${station.alias}  (${station.station})`}
                    rightActions={[
                        <IconButton
                            key={`inf_station_${key}`}
                            icon={this.props.isAdmin ? 'perm_device_information' : null}
                            primary
                            onClick={this.handleAlias.bind(this, station)}
                            disabled={!this.props.isAdmin}
                        />,
                        <IconButton
                            key={`del_station_${key}`}
                            icon={this.props.isAdmin ? "delete" : null}
                            primary
                            onClick={this.handleDeleteStation.bind(this, station.station)}
                            disabled={!this.props.isAdmin}
                        />
                    ]}
                    onClick={this.handleAlias.bind(this, station)}
                />
            );
        });

    }

    handleDialog() {

        let newState = this.state.Dialog;

        newState.active = false;

        this.setState({...this.setState, Dialog: newState});

        this.props.organizationActions.putStationOrg(this.props.shortName, {station_id: this.state.Dialog.station, alias: this.state.Dialog.alias}, (response, err) => {
            if (err) {
                console.log("ERROR -> " + response.toString());
                this.errorPopUp('Station has not been updated', "");
            } else {
                this.setState({...this.state, stations: response.data.stations});
            }
        });
    }

    render() {
        return (
            <div>
                <Dialog
                    actions={[{label: "Close", onClick: this.handleDialog}]}
                    active={this.state.Dialog.active}
                    onEscKeyDown={this.handleDialog}
                    onOverlayClick={this.handleDialog}
                    title={`Alias of ${this.state.Dialog.station}`}
                >
                    <Input className="inputForm" type="text" label="Alias" name="alias"
                           required={true}
                           value={this.state.Dialog.alias}
                           onChange={this.handleChange.bind(this, 'alias')}
                    />
                </Dialog>
                <h4 className="usersHeader">Stations</h4>
                <List>
                    {this.handleStations()}
                </List>
                {(this.props.noStations.length > 0 && this.props.global_admin) && <IconButton primary
                                                                className="buttonClose"
                                                                icon={this.state.addIconStation}
                                                                onClick={this.handleAddStation.bind(this)}
                />}
                {this.state.newStation ?
                    <Autocomplete className='inputForm' label="New Station"
                                  direction={"down"}
                                  value={''}
                                  source={this.props.noStations.map(ent => {return ent.id})}
                                  multiple={false}
                                  disabled={false}
                                  showSelectedWhenNotInSource={true}
                                  onChange={this.handleChange.bind(this, 'newStationValue')}
                    /> : ""}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        organizationProp: state.organizations.currentOrganizationDetails,
        global_admin: state.user.admin
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        organizationActions: bindActionCreators(OrganizationActions, dispatch)
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(StationListForm)



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminOrganizations/OrganizationForm/StationListForm.js